import { Contrato } from './contrato.entity';
import { UsuarioOnline } from './UsuarioOnline.entity';

export class ContratosUser {
    Contratos: Contrato[];
    UsuarioOnline: UsuarioOnline;
    ContratoSeleccionado: number
    TelefonoCorrecto: boolean;
    LoginA2P: boolean;
    IntentosCodigo: number;
    IntentosReenvio: number;
}


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/ContratosUser.entity.ts